import {FETCH_SNAPSHOTS, RESET_SNAPSHOTS, QCSnapshot} from './SnapshotActions';
import {handleActions} from 'redux-actions';

export interface QCSnapshotsState {
    snapshots: QCSnapshot[];
}

export const resetSnapshots = () => initialState;

export const setSnapshots = (
    state: QCSnapshotsState,
    {payload}: {payload: QCSnapshot[]}
): QCSnapshotsState => {
    return {
        snapshots: payload,
    };
};

export const initialState = {
    snapshots: [],
};

const handlers = {
    [FETCH_SNAPSHOTS]: setSnapshots,
    [RESET_SNAPSHOTS]: resetSnapshots,
};

export default handleActions(handlers, initialState);
